module.exports = __webpack_public_path__ + "71dac3476eb20efd303d8bd9871948e3.png";